import axios from 'axios';
import {backendHost} from '../../config';

export const getExchangeRates = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/rates`, {params});
};